<template>
  <div id="app">
    <navbar></navbar>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-2 col-xs-auto">
          <sidebar></sidebar>
        </div>
        <div id="nav" class="col-md-10 col-xs-auto">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/lib/font-awesome.min.css";
import "@/assets/css/lib/themify-icons.css";
import "@/assets/css/lib/weather-icons.css";
import "@/assets/css/lib/mmc-chat.css";
import "@/assets/css/lib/sidebar.css";
import "@/assets/css/lib/bootstrap.min.css";
import "@/assets/css/lib/unix.css";
import "@/assets/css/style.css";

import sidebar from "@/components/Sidebar.vue";
import navbar from "@/components/Navbar.vue";
export default {
  components: {
    sidebar,
    navbar
    //VueQRCodeComponent
  }
};
</script>
<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#nav {
  padding: 3%;
}
</style>
